<template>
  <v-dialog
    v-model="showDialog"
    :max-width="maxWidth"
    :fullscreen="fullscreen"
    :hide-overlay="hideOverlay"
    :scrollable="scrollable"
    persistent
  >
    <component :is="dialogComponent" />
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    ImagePreview: () => import('../ImagePreview.vue'),
    VideoPreview: () => import('../VideoPreview.vue'),
    UpdateAvailable: () => import('./UpdateAvailable.vue'),
    SubmitFeedback: () => import('./SubmitFeedback.vue'),
    SelectMediaType: () => import('./SelectMediaType'),
    CommitToRules: () => import('./CommitToRules'),
    GenderSelection: () => import('@/components/GenderSelection'),
    BuyMeCoffee: () => import('./BuyMeCoffee'),
    ReportRecord: () => import('./ReportRecord'),
  },
  computed: {
    ...mapGetters({
      dialogComponent: 'dialog/dialogComponent',
      showDialog: 'dialog/showDialog',
      maxWidth: 'dialog/maxWidth',
      fullscreen: 'dialog/fullscreen',
      hideOverlay: 'dialog/hideOverlay',
      scrollable: 'dialog/scrollable',
    }),
  },
  methods: {
    ...mapActions({
      closeDialog: 'dialog/closeDialog',
    }),
  },
};
</script>
